module.exports = __webpack_public_path__ + "static/media/DSC_2792.1acdf636.png";